import fetch             from '../../../utils/browser-fetch';
import busyActionFactory from '../../../busy';
import { addError }      from '../../../errors-dux';
import Errors            from '../../../errors';

/******************
 * Initial state
 */
const initialState = {
    busy: false,
    rulesText: {}
};

/******************
 * Non-async action types
 */
export const BUSY_REQUEST_RULES_TEXT = 'BUSY_REQUEST_RULES_TEXT';
export const RULES_TEXT_REQUESTED = 'RULES_TEXT_REQUESTED';

/******************
 * Reducer
 */
export default function rulesData( state = initialState, action ) {
    switch ( action.type ) {
        case BUSY_REQUEST_RULES_TEXT:
            return {
                ...state,
                busy: action.busy
            };
        case RULES_TEXT_REQUESTED:
            return  {
                ...state,
                rulesText: {
                    ...action
                }
            };
        default:
            return state;
    }
}


/******************
 * Action creators
 */
function rulesTextRequested( requested ) {
    return {
        type: RULES_TEXT_REQUESTED,
        ...requested
    };
}

const busyRequestingRulesText = busyActionFactory( BUSY_REQUEST_RULES_TEXT );
export function requestRulesText( cmmoKey ) {
    return dispatch => {
        
        dispatch( busyRequestingRulesText( true ) );

        return fetch( '/api/v1.0/cmmo/key/honeycombSystem/' + encodeURIComponent( cmmoKey ) )
            .then( ( { properties } ) => {

                if ( properties.length > 0 ) {
                    dispatch( rulesTextRequested( { [ cmmoKey ]: properties[ 0 ].value } ) );
                }

                dispatch( busyRequestingRulesText( false ) );
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_EXPORT_RULES_FAILED ) );
                dispatch( busyRequestingRulesText( false ) );
            } );
    };
}
